export default __webpack_public_path__ + "static/media/add_ticket.3bb29aaf.png";